import constanciasService from '../services/constancias.service';

const MOCK_TIPOS_CONSTANCIA = [
  { id: 'salarial', nombre: 'Constancia de salario' },
  { id: 'laboral', nombre: 'Constancia de tiempo laboral' },
];

// Mapeo de índice de tab → id de tipo de constancia
const TAB_TIPO_CONSTANCIA = MOCK_TIPOS_CONSTANCIA.map(t => t.id);

// ─── Store ────────────────────────────────────────────────────────────────────

export default {
  namespaced: true,

  state: {
    // Rol activo: 'empleado' | 'jefe_rrhh'
    roleActivo: 'empleado',
    // Tab activo en vista RRHH: 0 = Constancia de salario | 1 = Constancia de tiempo laboral
    tabActivo: 0,

    // Filtros comunes
    buscar: '',
    estadoSeleccionado: null,

    // Filtros empleado
    tipoConstanciaSeleccionado: null,

    // Filtros RRHH
    fechaDesde: null,
    fechaHasta: null,

    // Ítems seleccionados para aprobar masivamente (RRHH)
    seleccionados: [],

    // Catálogos
    estadosConstancias: [],
    tiposConstancia: MOCK_TIPOS_CONSTANCIA,

    // Listados
    constancias: [],
    // Paginación
    page: 1,
    per_page: 5,
    total: 3,
    last_page: 1,

    // controlar el toggle entre empleado y jefe
    esJefe: false,
    esTesorero: false,
  },

  getters: {
    esJefeRrhh: state => state.roleActivo === 'rrhh',

    getconstancias: state => {
      return state.constancias;
    },

    tituloPagina: state => {
      if (state.roleActivo === 'empleado') {
        return 'Lista de solicitudes de constancias';
      }
      return state.tabActivo === 0
        ? 'Lista de solicitudes de constancias salariales'
        : 'Lista de solicitudes de constancias de tiempo laboral';
    },

    paginacion: state => ({
      page: state.page,
      per_page: state.per_page,
      total: state.total,
      last_page: state.last_page,
    }),

    getEstadosConstancias: state => state.estadosConstancias,
    getTiposConstancia: state => state.tiposConstancia,
    getEsJefe: state => state.esJefe,
    getEsTesorero: state => state.esTesorero,
  },

  mutations: {
    setRoleActivo(state, role) {
      state.roleActivo = role;
      // Resetear tab, filtros y página al cambiar de rol
      state.tabActivo = 0;
      state.buscar = '';
      state.estadoSeleccionado = null;
      state.tipoConstanciaSeleccionado = null;
      state.fechaDesde = null;
      state.fechaHasta = null;
      state.seleccionados = [];
      state.page = 1;
    },

    setTabActivo(state, tab) {
      state.tabActivo = tab;
      state.seleccionados = [];
      state.page = 1;
    },

    setBuscar(state, value) {
      state.buscar = value;
    },

    setEstadoSeleccionado(state, estado) {
      state.estadoSeleccionado = estado;
    },

    setTipoConstanciaSeleccionado(state, tipo) {
      state.tipoConstanciaSeleccionado = tipo;
    },

    setFechaDesde(state, fecha) {
      state.fechaDesde = fecha;
    },

    setFechaHasta(state, fecha) {
      state.fechaHasta = fecha;
    },

    setSeleccionados(state, items) {
      const normalizedItems = items || [];
      const filteredItems = normalizedItems.filter(
        item => item?.estado?.nombre === 'Pendiente' || item?.estado?.id === 4
      );
      state.seleccionados =
        filteredItems.length === normalizedItems.length
          ? normalizedItems
          : filteredItems;
    },

    limpiarFiltros(state) {
      state.buscar = '';
      state.estadoSeleccionado = null;
      state.tipoConstanciaSeleccionado = null;
      state.fechaDesde = null;
      state.fechaHasta = null;
      state.page = 1;
    },

    setConstancias(state, items) {
      state.constancias = items;
    },

    setPaginacion(state, { page, per_page, total, last_page }) {
      state.page = page;
      state.per_page = per_page;
      state.total = total;
      state.last_page = last_page;
    },

    setEstadosConstancias(state, items) {
      state.estadosConstancias = items;
    },

    setTiposConstancia(state, items) {
      state.tiposConstancia = items;
    },
    setEsJefe(state, payload) {
      state.esJefe = payload;
    },
    setEsTesorero(state, payload) {
      state.esTesorero = payload;
    },
  },

  actions: {
    async cambiarRole({ commit, dispatch }, role) {
      commit('setRoleActivo', role);
      await dispatch('fetchConstancias', role);
    },

    async cambiarTab({ commit, dispatch }, tab) {
      commit('setTabActivo', tab);
      await dispatch('fetchConstancias');
    },

    actualizarBuscar({ commit }, value) {
      commit('setBuscar', value);
    },

    actualizarEstado({ commit }, estado) {
      commit('setEstadoSeleccionado', estado);
    },

    actualizarTipoConstancia({ commit }, tipo) {
      commit('setTipoConstanciaSeleccionado', tipo);
    },

    actualizarFechaDesde({ commit }, fecha) {
      commit('setFechaDesde', fecha);
    },

    actualizarFechaHasta({ commit }, fecha) {
      commit('setFechaHasta', fecha);
    },

    actualizarSeleccionados({ commit }, items) {
      commit('setSeleccionados', items);
    },

    async limpiarFiltros({ commit, dispatch }) {
      commit('limpiarFiltros');
      await dispatch('fetchConstancias');
    },

    async cambiarPagina({ commit, state, dispatch }, { page, per_page }) {
      commit('setPaginacion', {
        page,
        per_page: per_page || state.per_page,
        total: state.total,
        last_page: state.last_page,
      });
      await dispatch('fetchConstancias');
    },

    async fetchConstancias({ commit, state }, payload) {
      this.commit('utils/setLoader', true, { root: true });

      // vaciar las constancias actuales para mostrar el loader
      commit('setConstancias', []);

      try {

        const verComo = (state.roleActivo !== 'empleado' && state.esJefe && state.esTesorero) ? 'rrhh' : state.roleActivo;
        
        const params = { verComo };

        if (verComo === 'rrhh') {
          params.tipoConstancia = TAB_TIPO_CONSTANCIA[state.tabActivo];
        }
        if (verComo === 'empleado' && state.tipoConstanciaSeleccionado) {
          params.tipoConstancia =
            state.tipoConstanciaSeleccionado?.id ??
            state.tipoConstanciaSeleccionado;
        }
        if (state.buscar) params.search = state.buscar;
        if (state.estadoSeleccionado)
          params.estado =
            state.estadoSeleccionado?.id ?? state.estadoSeleccionado;
        if (state.fechaDesde) params.desde = state.fechaDesde;
        if (state.fechaHasta) params.hasta = state.fechaHasta;
        params.page = state.page;
        params.per_page = state.per_page;
        const { data = {} } = await constanciasService.fetchConstancias(params);

        const esJefe = data?.data?.esJefe || false;
        const esTesorero = data?.data?.esTesorero || false;

        commit('setConstancias', data?.data?.constancias || []);
        commit('setEsJefe', esJefe);
        commit('setEsTesorero', esTesorero);
        const meta = data?.data?.meta;
        if (meta) {
          commit('setPaginacion', {
            page: meta.current_page,
            per_page: meta.per_page,
            total: meta.total,
            last_page: meta.last_page,
          });
        }
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async aprobarSeleccionados({ commit, state, dispatch }, payload = null) {
      const idsFromPayload = Array.isArray(payload?.ids) ? payload.ids : null;
      const ids = idsFromPayload || state.seleccionados.map(item => item.id);

      if (!ids.length) return;
      this.commit('utils/setLoader', true, { root: true });
      try {
        await constanciasService.aprobarConstancias({ ids });
        commit('setSeleccionados', []);
        await dispatch('fetchConstancias');
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async aprobarConstancia({ dispatch, commit }, payload) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const { id, decision } = payload;
        await constanciasService.aprobarConstancia(id, decision);
        await dispatch('fetchConstancias');
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    async rechazarConstancia({ dispatch, commit }, payload) {
      this.commit('utils/setLoader', true, { root: true });
      try {
        const { id, decision } = payload;
        await constanciasService.rechazarConstancia(id, decision);
        await dispatch('fetchConstancias');
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },

    // catalogo estado de constancia (para filtros)
    async fetchEstadosConstancia({ commit }) {
      try {
        const response = await constanciasService.fetchEstadosConstancia();
        const data = response?.data?.data || [];
        // actualizar estados en el store
        commit('setEstadosConstancias', data);
      } catch (error) {
        throw error;
      }
    },
    // crear constancia
    async crearConstancia({ dispatch, commit }, payload) {
      let err = null;
      this.commit('utils/setLoader', true, { root: true });
      try {
        await constanciasService.crearConstancia({ tipo: payload });
        await dispatch('fetchConstancias');
      } catch (error) {
        throw error;
      } finally {
        this.commit('utils/setLoader', false, { root: true });
      }
    },
  },
};
